import Vue from "vue"
import { CouponType } from "@reef-os/utils/enums/couponType"
import { BusinessType } from "@reef-os/utils/enums/businessType"
import momentUtils from "@/moment-utils"
import EventModel from "@/models/EventModel"
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"

const vue = new Vue()
var moment = require("moment")
const uuidv1 = require("uuid/v1")

export default {
	gotBusiness(state, payload) {
		if (state.business != null && state.business != undefined) {
			if (state.business.id && state.business.id != payload.data.id) {
				state.menu = []
				state.categories = {}
				state.menuSchedules = {}
				state.restaurants = {}
				state.brands = []
				state.currentItem = {}
				state.suggestedItemSelected = {}
				state.cart = []
				state.lastCartUpdate = null
				state.purchase = false
				state.backup_mode = false
				state.deliveryDate = null
				state.businessEvents = []
				state.deliveryMode = null
				state.businessDropoffLocationId = null
			}
		}
		state.business = payload.data
		if (state.business.timezone_offset) {
			state.business.timezone_offset_adjusted =
				momentUtils.adjustOffsetToDST(state.business.timezone_offset)
		}

		if (
			state.business.tip_options &&
			state.business.tip_options.length > 0
		) {
			let addCustomOption = true
			state.business.tip_options.forEach((tipOption) => {
				if (tipOption.is_default == 1 && state.tipCustom == 0) {
					state.tipPer = tipOption.value
				}
				if (tipOption.value == -1) {
					addCustomOption = false
				}
			})
			if (addCustomOption) {
				state.business.tip_options.push({
					is_default: false,
					value: -1
				})
			} else {
				state.business.tip_options = state.business.tip_options.filter(
					(tipOption) => tipOption.value != -1
				)
			}
		} else {
			state.business.tip_options = [
				{
					is_default: 0,
					value: 10.0
				},
				{
					is_default: state.tipCustom <= 0 ? 1 : 0,
					value: 15.0
				},
				{
					is_default: 0,
					value: 20.0
				},
				{
					is_default: state.tipCustom > 0 ? 1 : 0,
					value: -1
				}
			]
			state.tipPer = state.tipCustom <= 0 ? 15.0 : state.tipCustom
		}

		state.business.menus.forEach((menu) => {
			if (
				menu.delivery_slots != undefined &&
				menu.delivery_slots != null &&
				menu.delivery_slots.length > 0
			) {
				menu.delivery_slots.sort((a, b) => {
					if (!a.time || !b.time) {
						return -1
					}
					return (
						momentUtils.numericalTime(a.time) -
						momentUtils.numericalTime(b.time)
					)
				})
				menu.slots = menu.delivery_slots.map((slot) => {
					if (slot.time) {
						return moment
							.utc(slot.time, "HH:mm:ss")
							.add(state.business.timezone_offset, "m")
							.format("HH:mm:ss")
					} else {
						return null
					}
				})
			} else {
				menu.slots = null
			}
		})
	},
	gotBusinessEvents(state, events) {
		state.businessEvents = events.map((event) => {
			return new EventModel(
				event,
				state.restaurants[event.restaurant_id],
				state.business
			)
		})
	},
	gotMenu(state, payload) {
		state.backup_mode = payload.backupMode

		payload.responses.forEach((response, index) => {
			let completeMenu = []
			if (!response || response.status != 200) {
				return
			}

			const menu = state.business.menus.find(
				(menu) => menu.id == payload.ids[index]
			)

			if (!menu) {
				return
			}

			const menuProducts = {}
			response.data.products.reduce((products, product) => {
				products[product.id] = product
				return products
			}, menuProducts)

			menu.products
				.filter((product) => menuProducts[product.id] !== undefined)
				.forEach((product) => {
					const extendedProduct = Object.assign(
						menuProducts[product.id],
						product,
						{
							restaurant_id: menu.restaurant_id,
							menu_id: menu.id,
							menu_type: menu.type,
							name: product.name
								? product.name
								: menuProducts[product.id].name,
							price: product.price
								? product.price
								: menuProducts[product.id].price,
							category_id: menuProducts[product.id].category_id
						}
					)
					completeMenu.push(extendedProduct)
				})
			menu.enrichedProducts = completeMenu
		})
		const productIds = {}
		const products = []
		state.business.menus
			.filter((menu) => payload.ids.includes(menu.id))
			.forEach((menu) => {
				productIds[menu.id] = []
				menu.enrichedProducts.forEach((product) => {
					if (!productIds[menu.id].includes(product.id)) {
						productIds[menu.id].push(product.id)
						products.push(product)
					}
				})
			})
		state.menu = products
	},
	gotRestaurants(state, payload) {
		const restaurants = payload.reduce((restaurants, restaurant) => {
			restaurants[restaurant.id] = restaurant
			return restaurants
		}, {})
		state.restaurants = restaurants
	},
	gotDelivery(state, payload) {
		state.delivery = payload.data.delivery
	},
	gotDeliveryStatus(state, payload) {
		state.deliveryStatus = payload
	},
	resetDeliveryStatus(state, payload) {
		state.deliveryStatusId = payload.status
		state.deliveredDate = payload.deliveredDate
	},
	gotDeliveryStatusId(state, payload) {
		state.deliveryStatusId = payload.data.delivery.status
		state.deliveredDate = payload.data.delivery.delivered_date
	},
	chargeCardFailed(state) {
		state.inPurchaseState = false
	},
	chargedCard(state, payload) {
		state.inPurchaseState = false
		if (payload.status == 200) {
			state.purchase = true
			state.orderID = payload.data.order_id
			state.paymentMethod = payload.paymentMethod
		}
	},
	setChargeKey(state) {
		state.charge_key = uuidv1()
	},
	setCurrentItem(state, payload) {
		state.currentItem = payload
	},
	setInPurchaseState(state, purchaseState) {
		state.inPurchaseState = purchaseState
	},
	calcMenuSchedules(state) {
		let menuSchedules = {}
		let restaurantSchedules = {}
		let restaurantScheduleExceptions = {}
		let weekDates = null

		state.business.menus.forEach((menu) => {
			const restaurant = state.restaurants[menu.restaurant_id]
				? state.restaurants[menu.restaurant_id]
				: null

			//Handle Restaurant Opening Hours Exceptions
			if (
				restaurant &&
				restaurant.opening_hours_exceptions &&
				restaurant.opening_hours_exceptions.length > 0
			) {
				if (!restaurantScheduleExceptions[menu.restaurant_id]) {
					const now = moment.utc().startOf("d")
					const maxDate = moment.utc().startOf("d").add(6, "d")
					restaurantScheduleExceptions[menu.restaurant_id] =
						restaurant.opening_hours_exceptions.reduce(
							(hourExceptions, hourException) => {
								const startTime = hourException.open_time
									? hourException.open_time
									: "00:00"
								const closeTime = hourException.close_time
									? hourException.close_time
									: "23:59"
								const startDate = moment.utc(
									`${hourException.start_date} ${startTime}`,
									"YYYY-MM-DD HH:mm:ss"
								)
								const endDate = moment.utc(
									`${hourException.end_date} ${closeTime}`,
									"YYYY-MM-DD HH:mm:ss"
								)
								if (
									startDate.isSameOrBefore(maxDate, "days") &&
									endDate.isSameOrAfter(now, "days")
								) {
									if (hourException.open_time) {
										startDate.add(
											state.business.timezone_offset,
											"m"
										)
									}
									if (hourException.close_time) {
										endDate.add(
											state.business.timezone_offset,
											"m"
										)
									}
									const startDow =
										momentUtils.normalizeDayOfWeek(
											startDate
										)
									let dows = []
									if (!startDate.isSame(endDate)) {
										if (!weekDates) {
											weekDates = []
											const workingDate = moment
												.utc()
												.startOf("d")
											for (var i = 0; i < 7; i++) {
												weekDates.push(
													workingDate.format(
														"YYYY-MM-DD"
													)
												)
												workingDate.add(1, "d")
											}
										}

										weekDates.forEach((date) => {
											const dateMoment = moment.utc(
												date,
												"YYYY-MM-DD"
											)
											if (
												dateMoment.isBetween(
													startDate,
													endDate,
													"days",
													"[]"
												)
											) {
												dows.push(
													momentUtils.normalizeDayOfWeek(
														dateMoment
													)
												)
											}
										})
									} else {
										dows.push(startDow)
									}
									const numericalCloseTime =
										closeTime == "23:59"
											? 2400
											: momentUtils.numericalTime(
													closeTime
											  )
									const schedules = {}
									dows.forEach((dow) => {
										const schedule =
											momentUtils.createScheduleFromRange(
												startTime,
												closeTime,
												dow,
												state.business.timezone_offset
											)
										for (let scheduleDow in schedule) {
											if (!schedules[scheduleDow]) {
												schedules[scheduleDow] = []
											}
											schedules[scheduleDow] = schedules[
												scheduleDow
											].concat(schedule[scheduleDow])
										}
									})
									hourExceptions.push({
										name: hourException.title,
										openTime: startTime,
										localOpenTime:
											startDate.format("HH:mm:ss"),
										numOpenTime:
											momentUtils.numericalTime(
												startTime
											),
										closeTime: closeTime,
										localCloseTime:
											endDate.format("HH:mm:ss"),
										numCloseTime: numericalCloseTime,
										dow: momentUtils.normalizeDayOfWeek(
											startDate
										),
										endDow: momentUtils.normalizeDayOfWeek(
											endDate
										),
										dows: dows,
										allDay:
											startDate.format("HH:mm") ==
												"00:00" &&
											endDate.format("HH:mm") == "23:59",
										schedules: schedules
									})
								}
								return hourExceptions
							},
							[]
						)
				}
			}

			//Normalize Business menu schedule
			const schedule = momentUtils.normalizeSchedule(
				menu.opening_hours,
				state.business.timezone_offset
			)

			if (
				restaurantScheduleExceptions[menu.restaurant_id] &&
				restaurantScheduleExceptions[menu.restaurant_id].length > 0
			) {
				restaurantScheduleExceptions[menu.restaurant_id].forEach(
					(hourException) => {
						//Adjust business menus for closures
						if (hourException.allDay) {
							hourException.dows.forEach((dow) => {
								schedule[dow] = []
							})
						} else {
							hourException.dows.forEach((dow) => {
								schedule[dow] = schedule[dow].reduce(
									(schedules, schedulePiece) => {
										if (
											hourException.schedules[
												schedulePiece.dow
											] &&
											hourException.schedules[
												schedulePiece.dow
											].length > 0
										) {
											let adjustedOpeningHours = null
											hourException.schedules[
												schedulePiece.dow
											].find((exceptionSchedulePiece) => {
												adjustedOpeningHours =
													momentUtils.intersectWithinRanges(
														exceptionSchedulePiece,
														schedulePiece
													)
												if (adjustedOpeningHours) {
													return true
												}
												return false
											})
											if (adjustedOpeningHours) {
												schedules.push(
													Object.assign(
														{},
														schedulePiece,
														{
															openTime:
																adjustedOpeningHours.openTime,
															closeTime:
																adjustedOpeningHours.closeTime
														}
													)
												)
											}
										} else {
											schedules.push(schedulePiece)
										}
										return schedules
									},
									[]
								)
							})
						}
					}
				)
			}

			//Handle Restaurant Opening Hours
			if (
				!restaurantSchedules[menu.restaurant_id] &&
				restaurant &&
				restaurant.opening_hours &&
				restaurant.opening_hours.length > 0
			) {
				//Adjust Restaurant opening hours for closures
				if (
					restaurantScheduleExceptions[menu.restaurant_id] &&
					restaurantScheduleExceptions[menu.restaurant_id].length > 0
				) {
					restaurantScheduleExceptions[menu.restaurant_id].forEach(
						(hourException) => {
							if (hourException.allDay) {
								restaurant.opening_hours =
									restaurant.opening_hours.filter(
										(hour) =>
											!hourException.dows.includes(
												hour.day_of_week
											)
									)
							} else {
								restaurant.opening_hours
									.filter((hour) =>
										hourException.dows.includes(
											hour.day_of_week
										)
									)
									.forEach((hour) => {
										hour.open_time = hourException.openTime
										hour.close_time =
											hourException.closeTime
									})
							}
						}
					)
				}
				restaurantSchedules[menu.restaurant_id] =
					momentUtils.normalizeSchedule(
						restaurant.opening_hours,
						restaurant.timezone_offset
					)
			}

			if (restaurantSchedules[menu.restaurant_id]) {
				momentUtils.offsetScheduleStart(
					schedule,
					restaurantSchedules[menu.restaurant_id],
					60
				)
			}
			menuSchedules[menu.id] = schedule
		})
		state.menuSchedules = menuSchedules
	},
	calcDiscount(state, payload) {
		if (payload && payload.status == 200) {
			const discData = payload.data
			state.discount = discData.discount
			state.coupon.code = discData.code
			state.coupon.id = discData.id
			state.coupon.couponType = discData.coupon_type
			state.coupon.token = discData.token ? discData.token : null
		}
	},
	gotBusinessVoucherRequests(state, payload) {
		if (payload && payload != null && payload.length > 0) {
			state.showVouchers = true
		} else {
			state.showVouchers = false
		}
	},
	setItem(state, payload) {
		state.currentItem = Object.assign({ quantity: 1 }, payload.product)
		state.suggestedItemSelected = {}
	},
	setEditableItem(state, item) {
		const menuItem = state.menu.find(
			(menuItem) =>
				menuItem.id == item.id && menuItem.menu_id == item.menu_id
		)
		const originalItem = JSON.parse(JSON.stringify(menuItem))
		const options = item.options
			? JSON.parse(JSON.stringify(item.options))
			: {}
		const editableItem = Object.assign({}, originalItem, {
			uuid: item.uuid,
			comments: item.comments,
			options: options,
			quantity: item.quantity,
			calcedPrice: item.calcedPrice
		})
		editableItem.metas.forEach((meta) => {
			if (item.options[meta.key]) {
				item.options[meta.key].forEach((option) => {
					meta.values.find((value) => {
						if (value.id == option.id) {
							value.checked = option.checked
						}
					})
				})
			}
		})
		state.currentItem = editableItem
		state.suggestedItemSelected = {}
	},
	selectSuggestedItem(state, item) {
		state.suggestedItemSelected = Object.assign({ quantity: 1 }, item)
	},
	gotOrderStatus(state, payload) {
		state.orderStatus = payload.data
	},
	gotReceipt(state, payload) {
		state.receipt = payload.data.data.receipts[0]
	},
	loading(state) {
		state.loading = true
	},
	loaded(state) {
		state.loading = false
	},
	loadingMenu(state) {
		state.loadingMenu = true
	},
	loadedMenu(state) {
		state.loadingMenu = false
	},
	setItemOption(state, payload) {
		const item = Object.assign({}, state.currentItem)
		item.options = state.currentItem.options || {}
		if (payload.maxAllowedValues == 1) {
			if (payload.option.checked) {
				item.options[payload.key] = []
				item.options[payload.key].push(payload.option)
			} else if (item.options[payload.key]) {
				delete item.options[payload.key]
			}
		} else {
			if (
				state.currentItem.options == undefined ||
				state.currentItem.options[payload.key] == undefined
			) {
				item.options[payload.key] = []
			} else {
				item.options[payload.key] =
					state.currentItem.options[payload.key]
			}

			const reachedMaxValues =
				payload.maxAllowedValues == 0
					? false
					: Object.keys(item.options[payload.key]).length >
					  payload.maxAllowedValues
			if (payload.option.checked && !reachedMaxValues) {
				item.options[payload.key].push(payload.option)
			}

			if (!payload.option.checked) {
				item.options[payload.key] = item.options[payload.key].filter(
					(key) => key.name != payload.option.name
				)
			}

			if (
				item.options[payload.key] &&
				item.options[payload.key].length == 0
			) {
				delete item.options[payload.key]
			}
		}
		let price = item.price
		if (item.options) {
			for (const meta of item.metas) {
				if (meta.key in item.options) {
					let options = item.options[meta.key]
					for (var i = 0; i < options.length; i++) {
						var option = options[i]
						if (option) {
							price += option.price
						}
					}
				}
			}
		}

		item.calcedPrice = parseFloat(price.toFixed(2))
		state.currentItem = Object.assign({}, item)
	},
	setCurrentItemComments(state, payload) {
		const item = Object.assign({}, state.currentItem)
		item.comments = payload
		state.currentItem = Object.assign({}, item)
	},
	setCurrentTipPer(state, payload) {
		state.tipPer = payload
	},
	setCurrentTipCustom(state, payload) {
		state.tipCustom = payload
	},
	setCurrentTable(state, payload) {
		state.table = `${payload}`
	},
	setUsername(state) {
		state.user.username =
			`${state.user.firstname}` + " " + `${state.user.lastname}`
	},
	setUserFirstName(state, payload) {
		state.user.firstname = payload
	},
	setUserLastName(state, payload) {
		state.user.lastname = payload
	},
	setUserEmail(state, payload) {
		state.user.email = payload
	},
	setDelivery(state, payload) {
		state.delivery = payload
	},
	setUserPhone(state, payload) {
		state.user.phone = payload
	},
	setDeliveryDate(state, payload) {
		if (state.business.type == BusinessType.RESIDENTIAL) {
			state.deliveryDate = {
				date: payload.date
			}
		} else if (payload && payload.date && payload.time) {
			state.deliveryDate = {
				time: payload.time,
				date: payload.date
			}
		} else {
			state.deliveryDate = null
		}
	},
	setCartItemsDeliveryTime(state, payload) {
		const isASAP = payload.deliveryTime == -1
		state.cart
			.filter((item) => payload.uuids.includes(item.uuid))
			.forEach((item) => {
				const deliverySlot = isASAP
					? null
					: moment(`${item.delivery_date} ${payload.deliveryTime}`)
							.utc()
							.format("YYYY-MM-DD HH:mm:ss")
				if (!item.delivery_time) {
					Vue.set(item, "delivery_time", payload.deliveryTime)
					Vue.set(item, "delivery_slot", deliverySlot)
				} else {
					item.delivery_time = payload.deliveryTime
					item.delivery_slot = deliverySlot
				}
			})
	},
	addToCart(state, payload) {
		const cart = state.cart.slice()
		const item = state.currentItem

		if (item.uuid) {
			const index = cart.findIndex(
				(cartItem) => cartItem.uuid === item.uuid
			)
			if (index > -1) {
				cart.splice(index, 1, payload.cartItem)
			} else {
				vue.bugsnag.notify(
					"Add to cart failed, unable to find item already in cart",
					(event) => {
						event.addMetadata("data", {
							item: item,
							cart: cart
						})
					}
				)
			}
		} else {
			cart.push(Object.assign({}, payload.cartItem))
		}

		if (payload.suggestedCartItem) {
			cart.push(payload.suggestedCartItem)
		}
		state.lastCartUpdate = new Date().getTime()
		state.cart = cart
	},
	batchAddToCart(state, payload) {
		const cart = state.cart.slice()
		payload.cartItems.forEach((cartItem) => {
			const index = cart.findIndex((item) => item.uuid === cartItem.uuid)
			if (index >= 0) {
				cart.splice(index, 1, cartItem)
			} else {
				cart.push(Object.assign({}, cartItem))
			}
		})
		state.lastCartUpdate = new Date().getTime()
		state.cart = cart
	},
	updateItemCount(state, payload) {
		const cart = state.cart.slice()
		const item = payload.item
		const quantity = payload.quantity
		cart.find((cartItem) => {
			if (item.uuid == cartItem.uuid) {
				item.quantity = quantity
				return true
			}
			return false
		})
		state.lastCartUpdate = new Date().getTime()
	},
	updateCurrentItemQuantity(state, quantity) {
		state.currentItem.quantity = quantity
	},
	removeItemFromCart(state, itemToRemove) {
		let cart = state.cart.slice()
		cart.find((item, index) => {
			const foundItem = item.uuid == itemToRemove.uuid
			if (foundItem) {
				cart.splice(index, 1)
			}
			return foundItem
		})
		state.cart = cart
		state.lastCartUpdate = new Date().getTime()
	},
	removeCoupon(state) {
		state.discount = 0
		state.coupon.code = ""
		state.coupon.id = 0
		state.coupon.couponType = CouponType.DEFAULT
		state.coupon.token = null
	},
	clearUserData(state) {
		state.user = {
			accessToken: "",
			refreshToken: "",
			username: "",
			email: "",
			phone: "",
			isVerified: 0,
			id: 0,
			smsOptIn: 0,
			businessId: 0,
			apartmentNumber: "",
			picture: "",
			paymentMethods: [],
			coupons: [],
			campaigns: []
		}
		state.address = {
			address: "",
			address2: "",
			city: "",
			state: "",
			zip: ""
		}
	},
	clearCart(state) {
		state.cart = []
		state.lastCartUpdate = null
	},
	clearOrder(state) {
		state.menu = []
		state.categories = {}
		state.menuSchedules = {}
		state.restaurants = {}
		state.brands = []
		state.currentItem = {}
		state.suggestedItemSelected = {}
		state.cart = []
		state.deliveryMode = null
		state.businessDropoffLocationId = null
		state.lastCartUpdate = null
		state.purchase = false
		state.coupon.code = ""
		state.coupon.id = 0
		state.coupon.couponType = CouponType.DEFAULT
		state.coupon.token = null
		state.discount = 0
		state.orderID = ""
		state.table = "0"
		state.charge_key = ""
		state.backup_mode = false
		state.loading = false
		state.loadingMenu = false
		state.paymentMethod = null
		state.tipCustom = 0
		state.tipPer = null
		state.orderStatus = {}
		state.receipt = {}
		state.deliveryStatus = {}
		state.delivery = {}
		state.deliveryDate = null
	},
	gotOrderSession(state, sessionOrder) {
		state.lastCartUpdate = new Date().getTime()
		state.cart = sessionOrder.cart
		state.coupon.id = sessionOrder.coupon_id
		state.coupon.couponType = sessionOrder.coupon_type
		let name = sessionOrder.name ? sessionOrder.name.split(" ") : ""
		if (sessionOrder.first_name) {
			state.user.firstname = sessionOrder.first_name
		} else {
			state.user.firstname = name && name[0] ? name[0] : name
		}

		if (sessionOrder.last_name) {
			state.user.lastname = sessionOrder.last_name
		} else {
			state.user.lastname =
				name && name[1] ? name[1] : state.user.firstname
		}
		state.user.phone = sessionOrder.phone
		state.user.username = `${state.user.firstname} ${state.user.lastname}`
		state.table = `${sessionOrder.table_num}`
		state.tipCustom = sessionOrder.tip
		state.tipPer = parseFloat(
			((sessionOrder.tip / sessionOrder.full_price) * 100).toFixed(2)
		)
		state.deliveryMode = sessionOrder.delivery_mode
		state.sessionOrderLoaded = true
		state.is_accessible_pickup = sessionOrder.is_accessible_pickup

		if (
			sessionOrder.dropoff_location_id &&
			sessionOrder.delivery_mode == DeliveryMode.DIRECT_TO_LOCATION
		) {
			state.businessDropoffLocationId = sessionOrder.dropoff_location_id
		}
	},
	gotCategories(state, categories) {
		state.categories = Object.assign({}, state.categories, categories)
	},
	userAuthenticated(state, payload) {
		if (payload.access_token) {
			state.user.accessToken = payload.access_token
			state.user.refreshToken = payload.refresh_token
		}
	},
	updatedUser(state, payload) {
		const user = payload.user
		if (user) {
			if (user.id != state.user.id) {
				state.user.paymentMethods = []
				state.user.coupons = []
				state.user.campaigns = []
				mixpanel.people.set({
					$name: user.first_name,
					$email: user.email,
					$phone: user.phone_number,
					business_id: user.business_id,
					sms_opt_in: user.sms_opt_in,
					is_verified: user.is_verified
				})
				if (state.business && state.business.id == user.business_id) {
					mixpanel.people.set_once({
						business_type: state.business.type,
						business_slug: state.business.slug
					})
				}
				mixpanel.identify(user.id)
			}

			if (user.first_name != undefined) {
				state.user.username = user.first_name
			}
			if (user.email != undefined) {
				state.user.email = user.email
			}
			if (user.phone_number != undefined) {
				state.user.phone = user.phone_number
			}
			if (user.id != undefined) {
				state.user.id = user.id
			}
			if (user.is_verified != undefined) {
				state.user.isVerified = user.is_verified
			}
			if (user.is_active != undefined) {
				state.user.isActive = user.is_active
			}
			if (user.sms_opt_in != undefined) {
				state.user.smsOptIn = user.sms_opt_in
			}
			if (user.business_id != undefined) {
				state.user.businessId = user.business_id
			}
			if (user.apartment_number != undefined) {
				state.user.apartmentNumber = user.apartment_number
			}
			if (user.picture != undefined) {
				state.user.picture = user.picture
			}
		}
	},
	updateUserNotification(state, payload) {
		if (!state.user.notifications) {
			state.user.notifications = []
		}
		if (payload.notification) {
			state.user.notifications.push(payload.notification)
		} else {
			state.user.notifications = state.user.notifications.filter(
				(notification) => notification.type != payload.type
			)
		}
	},
	gotUserCoupons(state, coupons) {
		state.user.coupons = coupons
	},
	gotUserCampaigns(state, campaigns) {
		state.user.campaigns = campaigns
	},
	gotUserPaymentMethods(state, methods) {
		state.user.paymentMethods = methods
	},
	gotUserOrders(state, orders) {
		state.orders = orders
	},
	updateOrderReorder(state, payload) {
		const order = state.orders.find((order) => order.id == payload.order.id)
		if (order) {
			order.canReorder = payload.canReorder
		}
	},
	addedPaymentMethod(state, paymentMethod) {
		state.user.paymentMethods.push(paymentMethod)
	},
	updatedPaymentMethod(state, updatedMethod) {
		if (updatedMethod.is_default != undefined) {
			state.user.paymentMethods.forEach((method) => {
				method.is_default = method.id == updatedMethod.id
			})
		}
	},
	deletedPaymentMethod(state, paymentMethodId) {
		state.user.paymentMethods = state.user.paymentMethods.filter(
			(method) => method.id != paymentMethodId
		)
	},
	markedFlag(state, payload) {
		state.temporaryFlag[payload.flag] = payload.value
	},
	setDeliveryMode(state, deliveryMode) {
		state.deliveryMode = deliveryMode
	},
	setDropoffLocationId(state, locationId) {
		state.businessDropoffLocationId = locationId
	},
	setAccessibility(state, is_accessible_pickup) {
		state.is_accessible_pickup = is_accessible_pickup
	},
	gotMenuBrands(state, payload) {
		state.brands = payload ? payload : []
	},
	setModalToShow(state, showModal) {
		state.showModal = showModal
	}
}
